export enum SptClassOption {
    SptClassA = 'A: AHI < 15',
    SptClassB = 'B: AHI > 15',
}
